type PropTypes = {
  className?: string
};

const EmailSentIcon = ({ className }: PropTypes) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 28 26"
      className={className}
    >
      <path
        fill="currentColor"
        d="m23 14-1.414 1.414L24.167 18H16a4 4 0 1 0 0 8h2v-2h-2a2 2 0 0 1 0-4h8.167l-2.583 2.587L23 24l5-5-5-5Z"
      />
      <path
        fill="currentColor"
        d="M8 18H2L1.997 2.906l11.434 7.916a1 1 0 0 0 1.138 0L26 2.91V12h2V2a2.003 2.003 0 0 0-2-2H2a2 2 0 0 0-2 1.996V18a2.003 2.003 0 0 0 2 2h6v-2ZM23.799 2 14 8.784 4.201 2H23.8Z"
      />
    </svg>
  )
}

export default EmailSentIcon
